<script>
export default {
  name: 'AdminInventoryHome',
  data() {
    return {
      session: this.$store.getters.getLocalSession,
      metrics: [
        { label: '보관 SKU', icon: 'inventory_2', value: '—', caption: '재고 API 연동 후 집계' },
        { label: '가용 재고', icon: 'check_circle', value: '—', caption: '파트너 소유 재고 기준' },
        { label: '입고 예정', icon: 'move_to_inbox', value: '—', caption: '입고 계획 연동 후 집계' },
        { label: '재고 경고', icon: 'warning', value: '—', caption: '안전 재고 정책 설정 필요' }
      ],
      capabilities: [
        { title: '입고 관리', description: '입고 예정, 검수, 적치 상태를 한 흐름으로 관리합니다.', icon: 'move_to_inbox' },
        { title: '재고 조회', description: 'SKU·로케이션별 가용/예약/보류 수량을 조회합니다.', icon: 'warehouse' },
        { title: '재고 이력', description: '입출고와 조정의 원인, 작업자, 시점을 추적합니다.', icon: 'history' }
      ]
    }
  }
}
</script>

<template>
  <q-page class="bg-grey-2 q-pa-md inventory-page">
    <div class="row items-center justify-between q-mb-lg">
      <div>
        <div class="text-h5 text-weight-bold">AONE Inventory</div>
        <div class="text-body2 text-grey-7 q-mt-xs">
          {{ session.partner_name || 'AONE' }}의 입고와 재고 수량, 이동 이력을 관리합니다.
        </div>
      </div>
      <q-chip color="blue-1" text-color="blue-9" icon="construction">
        데이터 연동 준비 중
      </q-chip>
    </div>

    <div class="row q-col-gutter-md q-mb-lg">
      <div v-for="metric in metrics" :key="metric.label" class="col-12 col-sm-6 col-lg-3">
        <q-card flat bordered class="full-height">
          <q-card-section>
            <div class="row items-center justify-between">
              <div class="text-caption text-grey-7">{{ metric.label }}</div>
              <q-icon :name="metric.icon" color="cyan-8" size="24px" />
            </div>
            <div class="text-h4 text-weight-bold q-my-sm">{{ metric.value }}</div>
            <div class="text-caption text-grey-6">{{ metric.caption }}</div>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <q-card flat bordered>
      <q-card-section>
        <div class="text-h6">Inventory 업무 범위</div>
        <div class="text-caption text-grey-7">상품 원장과 포장은 Fulfillment, 물리 수량과 이동 이력은 Inventory에서 담당합니다.</div>
      </q-card-section>
      <q-separator />
      <q-list separator>
        <q-item v-for="capability in capabilities" :key="capability.title" class="q-py-md">
          <q-item-section avatar>
            <q-avatar color="cyan-1" text-color="cyan-9" :icon="capability.icon" />
          </q-item-section>
          <q-item-section>
            <q-item-label class="text-weight-bold">{{ capability.title }}</q-item-label>
            <q-item-label caption>{{ capability.description }}</q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-badge outline color="grey-7">준비 중</q-badge>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card>
  </q-page>
</template>

<style scoped>
.inventory-page {
  min-height: calc(100vh - 58px);
}
</style>
